/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Legal_AndInputs */

const en_auth_legal_and = /** @type {(inputs: Auth_Legal_AndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`and`)
};

const pl_auth_legal_and = /** @type {(inputs: Auth_Legal_AndInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`oraz`)
};

/**
* | output |
* | --- |
* | "and" |
*
* @param {Auth_Legal_AndInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_legal_and = /** @type {((inputs?: Auth_Legal_AndInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Legal_AndInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_legal_and(inputs)
	return en_auth_legal_and(inputs)
});